import React from "react";
import { Box, Container, Paper, Typography } from "@mui/material";

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography component="h1" variant="h4" sx={{ mb: 2 }}>
            Stratify Beta
          </Typography>
          <Typography component="h2" variant="h5" sx={{ mb: 3 }}>
            {title}
          </Typography>
          {children}
        </Paper>
      </Box>
    </Container>
  );
};
